var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 5,
    fill: "#545565"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 4.75,
    stroke: "#545565",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28986 14.3931L4.8232 10.7098C4.61492 10.4885 4.61492 10.1297 4.8232 9.90842L5.57742 9.10703C5.7857 8.88572 6.1234 8.88572 6.33167 9.10703L8.66699 11.5883L13.669 6.27369C13.8772 6.05241 14.2149 6.05241 14.4232 6.27369L15.1774 7.07508C15.3857 7.29637 15.3857 7.65516 15.1774 7.87647L9.04411 14.3932C8.83582 14.6145 8.49813 14.6144 8.28986 14.3931Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 11.3333,
    fill: "white",
    transform: "translate(4.66699 4.66669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2a11dc5f5ea55ea4b086a6707b431d96.svg";
export { ForwardRef as ReactComponent };